import classNames from 'classnames';
import Checkbox from "../../../../features/customize-button/components/form/Checkbox";
import { isMobile } from '../../../../utilities/helpers';
import { t } from '../../../../utilities/translator';
import Tag from '../../../../components/ui/tag';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../../../../components/ui/accordion';

const groups = [[1, 6, 7], [4], [2], [3, 5]];

const DepartureList = (props) => {
  const {
    departures,
    fromWhereGroups,
    handleCheckbox,
    handleCheckboxGroup,
    hideSelected = false,
    listClosed = false,
  } = props;
  const selectedDepartures = departures.filter(item => item.active);

  const selectedLabels = Object.keys(fromWhereGroups).map(group => {
    let label = '';
    if (!departures.filter(d => d.group_id === +group).length) {
      label = '';
    }
    const thisGroupDepartures = departures.filter(d => d.group_id === +group);
    if (thisGroupDepartures.some(d => d.active)) {
      if (thisGroupDepartures.every(d => d.active)) {
        label = t('mainFilter.selected', { count: t('mainFilter.all') });
      } else {
        label = t('mainFilter.selected', { count: thisGroupDepartures.filter(d => d.active).length });
      }
    }
    return label;
  });

  const renderGroupList = (group) => {
    const mainGroup = group[0];
    const groupDepartures = departures.filter(d => group.includes(d.group_id));

    const mainDepartures = groupDepartures.filter(d => d.country_code === 'DE');
    const nearBorderDepartures = groupDepartures.filter(d => d.country_code !== 'DE');

    if (groupDepartures.length === 0) {
      return null;
    }

    const defaultValue = listClosed ? [] : [group.toString()];

    return (
      <Accordion
        key={group}
        type="multiple"
        collapsible
        defaultValue={isMobile() ? defaultValue : [group.toString()]}
        className="dl-group"
      >
        <AccordionItem value={group.toString()} className="border-none">
          <AccordionTrigger className="dlg-title py-2">
            <span className="flex gap-2 items-center leading-5">
              {t(`mainFilter.${fromWhereGroups[mainGroup]}`)}
              <span className="text-sm text-muted-foreground">
                {selectedLabels[+mainGroup - 1]}
              </span>
            </span>
          </AccordionTrigger>
          <AccordionContent className="flex flex-col gap-3 px-2">
            {groupDepartures.length > 1 && (
              <Checkbox
                label={<>{t('mainFilter.departureGroupAllLabel', { group: t(`mainFilter.${fromWhereGroups[mainGroup]}`) })}</>}
                checked={groupDepartures.every(d => d.active)}
                onChange={() => handleCheckboxGroup(+mainGroup, !groupDepartures.every(d => d.active))}
              />
            )}

            {mainDepartures.map((dep, i) => {
                return (
                  <Checkbox
                    key={dep.id+i}
                    label={<div className="flex gap-2 items-center w-full">{dep.value} <span className="ms-auto">{dep.id}</span></div>}
                    checked={dep.active}
                    onChange={() => handleCheckbox(dep.id)}
                  />
                )
              })
            }

            {nearBorderDepartures.length > 0 && (
              <>
                <div className="my-1 text-tertiary">{t(`mainFilter.near${fromWhereGroups[mainGroup]}Border`)}</div>
                {nearBorderDepartures.map((dep, i) => {
                  return (
                    <Checkbox
                      key={dep.id+i}
                      label={<div className="flex gap-2 items-center w-full">{dep.value} <span className="ms-auto">{t(`mainFilter.${dep.country_code}`)} · {dep.id}</span></div>}
                      checked={dep.active}
                      onChange={() => handleCheckbox(dep.id)}
                    />
                  )
                })}
              </>
            )}

          </AccordionContent>
        </AccordionItem>
      </Accordion>
    );
  }

  return (
    <div className="departure-list-wrap">
      {selectedDepartures.length > 0 ? (
        <div className={classNames("dl-selected", { hidden: hideSelected })}>
          <ul>
            {
              selectedDepartures.map((sd, i) => {
                return (
                  <Tag
                    key={sd.id+i}
                    type="engine-standard"
                    deletable
                    label={sd.value}
                    onDelete={() => handleCheckbox(sd.id)}
                  />
                )
              })
            }
          </ul>
        </div>
      ) : (
        <div className={classNames("dls-warning flex gap-3 items-center", { hidden: hideSelected })}>
          <i className="ri-close-line" />
          <div className="text-tertiary">{t('mainFilter.select_at_least_one_airport')}</div>
        </div>
      )}
      <div className="departure-list flex flex-col">
        {groups.map((column) => renderGroupList(column))}
      </div>
    </div>
  );
}

export default DepartureList;
